<div class="agent-rating-button-container">
    <label id="rate-agent-label">Rate this agent:</label>
    <div class="agent-rating-button" (click)="toggleLike()" [ngClass]="likedByUser ? 'liked': ''">
        <div class="pending-like-button" *ngIf="!likedByUser">
            <img src="../assets/icons/thumbs%20up/thumbsup-16px-gray-bold.svg" class="thumbs-up-icon">
            <span class="like-text">Like</span>
        </div>
        <app-agent-rating *ngIf="likedByUser" [agent]="agent" [displayLikeCountOnly]="true" />
    </div>
</div>